import styled from 'styled-components';

export const Container = styled.div`
    position: relative;
    width: ${props => props.size}px;
    height: ${props => props.size}px;

    svg {
        transform: rotate(-90deg);
    }
`;

export const Value = styled.div`
    position: absolute;
    inset: 0;
    display: grid;
    place-items: center;
`;

export const Infinito = styled.span`
    display: inline-block;
`;
